'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _progressBar = require('../../src/styles/progress-bar.scss');

var _progressBar2 = _interopRequireDefault(_progressBar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProgressBar = function ProgressBar(props) {
  var additionalClassName = props.additionalClassName,
      widthPercent = props.widthPercent;


  return _react2.default.createElement(
    'div',
    { className: _progressBar2.default['progress-bar'] + ' ' + additionalClassName },
    _react2.default.createElement(
      'div',
      { className: '' + _progressBar2.default['progress-bar__inner'], style: { width: widthPercent + '%' } },
      ' '
    )
  );
};

ProgressBar.displayName = 'ProgressBar';

ProgressBar.defaultProps = {
  additionalClassName: '',
  widthPercent: 0
};

ProgressBar.propTypes = {
  additionalClassName: _propTypes2.default.string,
  widthPercent: _propTypes2.default.number
};

exports.default = ProgressBar;


// WEBPACK FOOTER //
// ./components/breakdown-row/lib/components/progress-bar.js